// extracted by mini-css-extract-plugin
module.exports = {"component":"Caret_component__1CuLV","darkTheme":"Caret_darkTheme__3Eml5","lightTheme":"Caret_lightTheme__3K2GJ","open":"Caret_open__UO1OQ"};